import { CheckCircleIcon } from "staysure-component-library";

type DetailSectionType = {
  title: string;
  description: string;
  color: string;
};

function DetailSection({
  title,
  description,
  color,
}: Readonly<DetailSectionType>) {
  return (
    <div className="self-stretch justify-start items-start gap-spacing-xs inline-flex">
      <div>
        <CheckCircleIcon
          fill={color}
          stroke="#FFFFFF"
          data-testid="check-circle-icon"
        />
      </div>
      <div className="grow shrink basis-0 flex-col justify-center items-start gap-spacing-xxs inline-flex">
        <div className="text-confirmation-body text-2xs font-semibold sub-section-header-font leading-[24px]">
          {title}
        </div>
        <div className="self-stretch text-confirmation-body text-[14px] font-normal body-font leading-[21px]">
          {description}
        </div>
      </div>
    </div>
  );
}

export default DetailSection;
